import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';
import * as apis from '@truckdown/jsclient/apis';
import * as locations from '@truckdown/locations';
import { defineComponent, ref, computed, reactive } from 'vue';
import { email, required, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { ILegacyListingService } from '../Services/ILegacyListingService';
import { ForwardLocationModel } from '../Services/ForwardLocationModel';

sys.fontLibrary.add(icons.solid.faEnvelope);
sys.fontLibrary.add(icons.solid.faMessage);
sys.fontLibrary.add(icons.solid.faXmark);

var setupUserData = function () {
    var ctx = sys.framework.context;

    const isAuth = computed(() => {
        return ctx.isAuthenticated();
    });
    const isAce = computed(() => {
        return ctx.isInRole(apis.framework.SecurityConstants.Roles.FleetUserRole);
    });

    return {
        isAuth,
        isAce
    };
}

export default defineComponent({
    props: {
        listing: {
            type: Object as () => locations.Listing,
            required: true
        }
    },
    setup: function (props, ctx) {
        var listing = props.listing as locations.Listing;
        const method = ref<'email' | 'sms'>('email');
        const message = ref<string>('');

        const label = computed(() => {
            if (method.value == 'sms') {
                return 'Recipient Phone Number';
            }
            return 'Recipient Email';
        });

        const state = reactive({
            emailAddress: '',
            mobileNumber: ''
        })

        const selectEmail = function () {
            method.value = 'email';
        }

        const selectSms = function () {
            method.value = 'sms';
        }

        const isInputProvided = function () {
            if (method.value == 'sms') {
                return state.mobileNumber.length > 0;
            }
            return state.emailAddress.length > 0;
        }

        const phoneRegex = /^1?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

        const isValidPhoneNumber = function (number: string) {
            if (!number || number.length == 0) {
                return true;
            }
            const match = number.match(phoneRegex);
            if ((match?.length ?? 0) > 0) {
                return true;
            }
            return false;
        }

        const validationRules = {
            emailAddress: {
                isInputProvided: helpers.withMessage('A valid email address is required', isInputProvided),
                email
            },
            mobileNumber: {
                isInputProvided: helpers.withMessage('A valid phone number is required', isInputProvided),
                isValidPhoneNumber: helpers.withMessage('Phone number is not in a valid format', isValidPhoneNumber)
            }
        };

        const shareLocation = async function (ev: Event) {
            const isFormCorrect = await v$.value.$validate();

            if (isFormCorrect) {

                var service = sys.framework.getRequiredService<ILegacyListingService>('ILegacyListingService');
                let address = method.value == 'sms' ? state.mobileNumber : state.emailAddress;
                var model = new ForwardLocationModel(
                    listing.id,
                    address
                );

                var res = await service.forwardLocation(model);
                if (res.ok) {
                    message.value = 'Listing was sent to ' + address + '.';
                } else {
                    message.value = 'There was an error sharing the listing to ' + address + '.  Please double check the address.';
                }
            }
        }

        const closeForm = function (ev: Event) {
            sys.events.emit('close-listing-form', props.listing.id);
        }

        const v$ = useVuelidate(validationRules, state);

        const moreInfoUrl = computed(() => {
            if (sys.framework.context.sys == 'planrv') {
                return '/shop/features';
            }
            return '/shop/fleets';
        });

        return {
            ...setupUserData(),
            method,
            label,
            state,
            selectEmail,
            selectSms,
            shareLocation,
            closeForm,
            v$,
            message,
            moreInfoUrl
        }
    }
});
